export const RESEND_COOLDOWN_SECONDS = 20;

/** Whole seconds until a resend is allowed again; 0 once it is. */
export function secondsUntilResend(readyAtMs: number, nowMs: number): number {
  return Math.max(0, Math.ceil((readyAtMs - nowMs) / 1000));
}

export function resendLabel(
  secondsLeft: number,
  sendCount: number,
  noun: "code" | "link" = "code",
): string {
  const base =
    secondsLeft > 0 ? `Resend ${noun} in ${secondsLeft}s` : `Resend ${noun}`;
  return sendCount > 1 ? `${base} (sent ${sendCount} times)` : base;
}

/** The label on a button that sends again: the wait, then the plain action. */
export function retryLabel(secondsLeft: number): string {
  return secondsLeft > 0 ? `Retry in ${secondsLeft}s` : "Retry";
}
